import {useRef} from "react"

export const useDebounce = (milliseconds = 2_000) => {
    const timerId = useRef(0)

    return (handler: () => unknown) => {
        window.clearTimeout(timerId.current)
        timerId.current = window.setTimeout(handler, milliseconds)
    }
}